import { withDependencyWrites } from './write-intents';
import type { PortWithWrites } from '../../port-contract';
import { statusId, houseRuleId } from './catalog';
import * as php from '../../php-compat';
import { array } from './shared';
import { call, r, put, type Ref, type DispatchEnv } from './dispatch';

function status(target: Ref, affected: Ref, name: string, roll: unknown, env: DispatchEnv, log?: boolean): void {
    const args: Record<string, unknown> = { status_connected_id: '', status_caster_arr: r(target), status_target_arr: r(target),
        status_casting_targets_arr: '', affected_ids: r(affected), status_origin_id: '', status_item_id: statusId(env,name), status_ends: 0, roll_id: roll };
    if (log !== undefined) args.log_message = log;
    call(env, 'apply_status_effect', args);
}
function log(target: unknown, roll: unknown, type: string, env: DispatchEnv): void {
    call(env, 'insert_log_message', { roll_id: roll, roll_type_1: type, roll_item_id: statusId(env,'dying'),
        item_id_used_arr: array(['item_type', 'status_effect'], ['item_name', 'Dying']), roll_by_arr: target, roll_to_arr: '' });
}
/** PHP: apply_maimed_status (includes/functions/janus/encounter/dying_recovery_helpers.php:49) */
export function applyMaimedStatus(target: Ref, affected: Ref, roll: unknown, env: DispatchEnv): PortWithWrites<null> {
 return withDependencyWrites(env, env => {
    status(target, affected, 'maimed', roll, env);
return null;

 });
}
/** PHP: log_recovery (includes/functions/janus/encounter/dying_recovery_helpers.php:100) */
export function logRecovery(roll: unknown, target: unknown, env: DispatchEnv): PortWithWrites<null> {
 return withDependencyWrites(env, env => { log(target, roll, 'recovers', env); return null;

 });
}
/** PHP: log_stabilization (includes/functions/janus/encounter/dying_recovery_helpers.php:121) */
export function logStabilization(target: unknown, roll: unknown, env: DispatchEnv): PortWithWrites<null> {
 return withDependencyWrites(env, env => { log(target, roll, 'stabilized', env); return null;

 });
}
/** PHP: log_consciousness (includes/functions/janus/encounter/dying_recovery_helpers.php:186) */
export function logConsciousness(target: unknown, roll: unknown, env: DispatchEnv): PortWithWrites<null> {
 return withDependencyWrites(env, env => { log(target, roll, 'is_conscious', env); return null;

 });
}
/** PHP: handle_recovery_progress (includes/functions/janus/encounter/dying_recovery_helpers.php:142) */
export function handleRecoveryProgress(recovery: unknown, dying: unknown, stratum: unknown, target: Ref, affected: Ref, roll: unknown, env: DispatchEnv): PortWithWrites<null> {
 return withDependencyWrites(env, env => {
    stratum = Number(recovery) - Number(dying);
    if (Number(stratum) >= 0) {
        call(env, 'remove_status_effect_item_id_single_connection', { target_arr: r(target), affected_ids: r(affected), status_item_id: statusId(env,'unconscious') });
        call(env, 'log_consciousness', { target_arr: r(target), roll_id: roll });
    }
    status(target, affected, 'recovery_state', null, env);
return null;

 });
}
/** PHP: apply_recovery_state (includes/functions/janus/encounter/dying_recovery_helpers.php:218) */
export function applyRecoveryState(target: Ref, affected: Ref, recovery: unknown, roll: unknown, env: DispatchEnv): PortWithWrites<null> {
 return withDependencyWrites(env, env => {
    if (php.equal(recovery, 1)) status(target, affected, 'recovery_state_1', roll, env, false);
    else if (php.equal(recovery, 2)) {
        call(env, 'remove_status_effect_item_id_single_connection', { target_arr: r(target), affected_ids: r(affected), status_item_id: statusId(env,'recovery_state_1'), roll_id: roll });
        status(target, affected, 'recovery_state_2', roll, env, false);
    }
return null;

 });
}
/** PHP: handle_dying_progress (includes/functions/janus/encounter/dying_recovery_helpers.php:280) */
export function handleDyingProgress(target: Ref, affected: Ref, result: unknown, main: unknown, dying: unknown, stratum: unknown, roll: unknown, env: DispatchEnv): PortWithWrites<null> {
 return withDependencyWrites(env, env => {
    const next = Number(dying) + 1, nextStratum = Number(stratum) - 1;
    if (next >= 3) {
        call(env, 'drop_target_equipped_in_hand_inventory', { target_arr: r(target), affected_ids: r(affected), roll_id: roll });
        call(env, 'remove_recovery_and_dying_states', { target_arr: r(target), affected_ids: r(affected) });
        call(env, 'insert_log_message', { roll_id: roll, roll_type_1: 'dies', roll_item_id: '', item_id_used_arr: '', roll_by_arr: r(target), roll_to_arr: '' });
        call(env, 'kill_creature', { encounter_creature_arr: r(target), affected_ids: r(affected) });
        put(target, ['encounter_creatures', 'encounter_creature_dead'], 1);
        put(target, ['encounter_creatures', 'v_current'], 0);
        return null;
    }
    if (nextStratum < 0) {
        status(target, affected, 'unconscious', roll, env, false);
        call(env, 'drop_target_equipped_in_hand_inventory', { target_arr: r(target), affected_ids: r(affected), roll_id: roll });
        call(env, 'insert_log_message', { roll_id: roll, roll_type_1: 'slipping_away', roll_item_id: '', item_id_used_arr: '', roll_by_arr: r(target), roll_to_arr: '' });
    }
    status(target, affected, 'dying_state', roll, env);
    if (php.compare(result, 5) <= 0 && php.truthy(env.deps.campaign_arr_has_active_house_rule_type(env.deps.ft_campaign_context(target.value), houseRuleId(env,'maimed_on_dying_stratum_fail_by_5'))))
        call(env, 'apply_maimed_status', { target_arr: r(target), affected_ids: r(affected), roll_id: roll });
return null;

 });
}
